import { type IncomingSuperlikeCard } from '@services/SuperlikesService';
import { type User } from '@services/UsersService';

/** A card from GET /superlikes/incoming: its sender superliked the viewer. */
export const isIncomingSuperlikeCard = (
  profile: User | undefined,
): profile is IncomingSuperlikeCard =>
  !!profile &&
  'superlike' in profile &&
  typeof profile.superlike === 'object' &&
  profile.superlike !== null;
